export default __webpack_public_path__ + "static/media/goal-user-icon.c42db7b3.svg";